define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi/action/EmailController",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/xml",
	"csi/xml/Search",
	"csi/widget/MessageDialog"
], function(declare,lang,Memory,EmailController,PostRequest,locale,xml,Search,MessageDialog) {

	return declare(EmailController, {

		hasToConfirmAction: function() {
			return true;
		},

		confirmAction: function(params) {
			// summary: issue request so as to be able to receive return value
			this.setProgress();

			new PostRequest("Sourcing", "SRLineItemHasDocuments")
				.addParameter("ParentURL", this.m_urlNode)
				.post({}).then(lang.hitch(this, this._onHasDocuments));
		},

		_onHasDocuments: function(/*Response*/response) {
			if (response.getReturnValue()) {
				this.preProcess();
			} else {
				this.displayErrorDialog({
					materialIcon: MessageDialog.ICON_WARNING,
					message: locale.resource("NoDocumentToZip_Error"),
					title: locale.resource("WARNING")
				});
			}
		},

		getAttachmentsStore: function() {
			// summary: returns the attachments' store
			return new Memory({
				idProperty: "$",
				nameProperty: "Name",
				labelProperty: "Name",
				data: [
				    {$: "centric:", Name: this._getAttachmentName()}
				]
			});
		},

		getInitialValues: function() {
			// summary: get initial values for Email form
			var initialValues = this.inherited(arguments);

			initialValues.attachments = ["centric:"];

			return initialValues;
		},

		getUsersStoreOptions: function() {
			// summary: pull all Suppliers and Contacts from Suppliers into the list of available email addresses
			var options = this.inherited(arguments);

			var search = new Search({Module:EmailController.USERS_STORES_MODULE, Operation:EmailController.USERS_STORES_OPERATION});
			search.setLimitPath(this.m_urlParent, xml.path("SRSuppliers"));
			search.setLimitPath(this.m_urlParent, xml.path("SRSuppliers","Contacts"));
			var q = search.getQuery();
			q.Attr("Email", xml.OP_NOT_EQUALS, "");

			options.request = search.getRequest();

			return options;
		},

		toWriter: function() {
			// summary: set values to email message
			var call = this.inherited(arguments);

			call.setModuleOperation("Sourcing", "LineItemZipEmail");
			call.addParameter("URL", xml.ATTR_REF, this.m_urlNode);
			call.addParameter("AttachmentName", xml.ATTR_STRING, this._getAttachmentName());

			return call;
		},

		_getAttachmentName: function() {
			var srLineItem = this.getNode();
			return srLineItem.$Name+".zip";
		}
	});
});